export default {
    highcharts: {
        'reset-zoom-title': 'Сбросить увеличение',

        'decimal-point': ',',
        'thousands-sep': ' ',

        Mon: 'Пн',
        Tue: 'Вт',
        Wed: 'Ср',
        Thu: 'Чт',
        Fri: 'Пт',
        Sat: 'Сб',
        Sun: 'Вс',
        Jan: 'Янв',

        January: 'Январь',
        Feb: 'Фев',
        February: 'Февраль',
        Mar: 'Мар',
        March: 'Март',
        Apr: 'Апр',
        April: 'Апрель',
        May: 'Май',
        Jun: 'Июн',
        June: 'Июнь',
        Jul: 'Июл',
        July: 'Июль',
        Aug: 'Авг',
        August: 'Август',
        Sep: 'Сен',
        September: 'Сентябрь',
        Oct: 'Окт',
        October: 'Октябрь',
        Nov: 'Ноя',
        November: 'Ноябрь',
        Dec: 'Дек',
        December: 'Декабрь',
    },
    chartkit: {
        error: 'Ошибка',

        loading: 'Загрузка',

        'tooltip-point-format-size': 'Размер',
        'tooltip-sum': 'Сумма',
        'tooltip-rest': 'Остальные',

        'error-incorrect-key-value-intro': 'Некорректный формат объекта переданного как значение в',
        'error-incorrect-key': ', ключи объекта должны быть преобразуемы в целое число',
        'error-incorrect-value':
            ', значением объекта может быть либо строка, либо функция возвращающая строку',
        'label-palette-editor': 'Редактор цветовой схемы',
        'label-load-from-file': 'Загрузить из файла',
    },
    'chartkit-table': {
        'message-no-data': 'Нет данных',
        'paginator-rows': 'Строки',
    },
    'chartkit-ymap-legend': {
        'label-more': 'Показать ещё {{count}}',
        'label-hide': 'Свернуть',
        'label-heatmap': 'Тепловая карта',
    },
};
